import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  // Handle both DD/MM/YYYY and ISO formats
  if (dateString.includes('/')) return dateString;
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB'); // DD/MM/YYYY
  } catch {
    return dateString;
  }
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB');
  } catch {
    return dateString;
  }
}

export function formatNumber(num, decimals = 2) {
  if (num === null || num === undefined) return '';
  return Number(num).toFixed(decimals);
}

export function getTodayFormatted() {
  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  return `${day}/${month}/${year}`;
}

export function parseIrishDate(dateStr) {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split('/');
  return new Date(year, month - 1, day);
}

export function getStatusColor(status) {
  switch (status) {
    case 'draft':
      return 'status-draft';
    case 'locked':
      return 'status-locked';
    case 'dispatched':
      return 'status-dispatched';
    case 'cancelled':
      return 'status-cancelled';
    default:
      return 'bg-gray-100 text-gray-700';
  }
}

export function getRoleLabel(role) {
  switch (role) {
    case 'super_admin':
      return 'Super Admin';
    case 'admin':
      return 'Admin';
    case 'dpo':
      return 'Data Protection Officer';
    case 'ops_user':
      return 'Ops User';
    case 'read_only':
      return 'Read Only';
    default:
      return role;
  }
}

export function canEdit(role) {
  return ['super_admin', 'admin', 'ops_user'].includes(role);
}

export function canManageUsers(role) {
  return ['super_admin', 'admin'].includes(role);
}

export function canManageSettings(role) {
  return ['super_admin', 'admin'].includes(role);
}
